<template>
  <div>
    <v-form ref="form">
      <v-select
        id="group-solution-select"
        class="group-solution-combo"
        v-model="grupoSolucaoIds"
        item-text="nome"
        item-name="grupoSolucaoId"
        item-value="grupoSolucaoId"
        :items="gruopSolutions"
        :rules="rules"
        :disabled="disabled"
        :label="
          title
            ? title
            : isAT
            ? 'Grupos de Iniciativas'
            : isGov
            ? 'Grupos de fases'
            : 'Grupos de Soluções'
        "
        :placeholder="
          title
            ? title
            : isAT
            ? 'Grupos de Iniciativas'
            : isGov
            ? 'Grupos de fases'
            : 'Grupos de Soluções'
        "
        clearable
        @change="$emit('changeGroupSolution', grupoSolucaoIds)"
      >
        <template #item="{ item }">
          <div v-if="mostrarTipo" class="nomeTipo">
            <div v-if="item.disabled" class="tipo">Máximo de 5 eixos</div>
            <div v-else-if="item.tipo" class="tipo">{{ item.tipo }}</div>
            <div>{{ item.nome }}</div>
          </div>
          <span v-else>{{ item.nome }}</span>
        </template>
        <template slot="no-data">
          Nenhum
          {{
            isAT
              ? "Grupo de Iniciativa"
              : isGov
              ? "Grupo de Fase"
              : "Grupo de Solução"
          }}
          Retornado
        </template>
      </v-select>
    </v-form>
  </div>
</template>

<script>
import { groupSolutionAPI } from "../API/GroupSolutionAPI";
import { mapActions, mapGetters } from "vuex";
import { compare } from "@/helpers/orderByAsc";

export default {
  name: "AppGroupSolutionCombobox",
  props: [
    "filter",
    "groupSolution",
    "groupSolutionId",
    "title",
    "mostrarTipo",
    "maximoEixos",
    "rules",
    "disabled",
  ],
  mounted() {
    this.loadGroupSolution();
    this.grupoSolucaoIds = this.groupSolutionId;
  },

  computed: {
    ...mapGetters(["loading", "isAT", "isGov", "config", "groupsConfig"]),
  },
  methods: {
    async check() {
      if (!this.$refs.form) return true;
      const isValid = await this.$refs.form.validate();
      return isValid;
    },
    loadGroupSolution() {
      groupSolutionAPI
        .list()
        .then((resp) => {
          this.gruopSolutions = resp.data.sort((a, b) => compare(a, b, "nome"));

          if (this.mostrarTipo)
            this.gruopSolutions.sort((a, b) => {
              // Primeiro ordena pelo campo 'tipo'
              if (a.tipo < b.tipo) return -1;
              if (a.tipo > b.tipo) return 1;

              // Se 'tipo' for igual, ordena pelo campo 'nome' usando localeCompare
              return a.nome.localeCompare(b.nome, "pt-BR");
            });
        })
        .catch();
    },
  },
  data() {
    return {
      gruopSolutions: [],
      grupoSolucaoIds: null,
    };
  },
  watch: {
    filter: {
      handler(val) {
        this.grupoSolucaoIds = val.grupoSolucaoId;
      },
      deep: true,
    },
    groupSolutionId: function (val) {
      this.grupoSolucaoIds = val;
    },
    maximoEixos: {
      handler(val, oldVal) {
        if (!val) return;

        if (val.length == 5) {
          this.gruopSolutions = this.gruopSolutions.map((item) => ({
            ...item,
            disabled: val.includes(item.grupoSolucaoId) ? false : true,
          }));
        } else {
          this.gruopSolutions = this.gruopSolutions.map((item) => ({
            ...item,
            disabled: false,
          }));
        }
      },
      deep: true,
    },
    groupSolution: {
      handler(val, oldVal) {
        this.gruopSolutions = val;
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss">
.nomeTipo {
  display: flex;
  column-gap: 10px;
  .tipo {
    color: #fff;
    font-size: 14px;
    background: #a4a3a3;
    border-radius: 10px;
    padding: 2px 8px;
    text-align: center;
  }
}
</style>
